import { render, staticRenderFns } from "./createEsgStandard.vue?vue&type=template&id=5a761f2c&scoped=true"
import script from "./createEsgStandard.vue?vue&type=script&lang=js"
export * from "./createEsgStandard.vue?vue&type=script&lang=js"
import style0 from "./createEsgStandard.vue?vue&type=style&index=0&id=5a761f2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a761f2c",
  null
  
)

export default component.exports